module.exports = "/assets/e2799b5ef5beea5eaa4597a9200ac5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DE.png
// module id = 1298
// module chunks = 0